export type ThemePreference = "dark" | "light";

const THEME_COOKIE = "petchef_theme";
const THEME_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function parseThemePreference(cookieHeader: string): ThemePreference | null {
  const value = cookieHeader
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${THEME_COOKIE}=`))
    ?.slice(THEME_COOKIE.length + 1);
  return value === "dark" || value === "light" ? value : null;
}

export function createThemeCookie(theme: ThemePreference, secure: boolean): string {
  return `${THEME_COOKIE}=${theme}; Path=/; Max-Age=${THEME_MAX_AGE_SECONDS}; SameSite=Lax${secure ? "; Secure" : ""}`;
}

export function readThemePreference(): ThemePreference {
  if (typeof document === "undefined") return "light";
  return parseThemePreference(document.cookie) ?? "light";
}

function applyThemePreference(theme: ThemePreference): void {
  if (typeof document === "undefined") return;
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
}

export function saveThemePreference(theme: ThemePreference): void {
  applyThemePreference(theme);
  if (typeof document === "undefined") return;
  document.cookie = createThemeCookie(theme, window.location.protocol === "https:");
}

export function initializeThemePreference(): void {
  applyThemePreference(readThemePreference());
}
